import { Component } from '@angular/core';
import { AdvancedSearchBridgeService } from 'app/shared/services/core/advanced-search-bridge/advanced-search-bridge.service';

@Component({
    selector: 'app-shell-topbar',
    templateUrl: './app-shell-topbar.component.html',
    styleUrls: ['./app-shell-topbar.component.scss'],
})
export class AppShellTopbarComponent {
    constructor(readonly advancedSearchBridge: AdvancedSearchBridgeService) { }

    openAdvancedSearch(): void {
        this.advancedSearchBridge.requestOpen();
    }

}
